import { EventHandler } from '../EventHandler';
export var createBuilder = function (root) { return ({
    events: function (eventType) { return ({
        select: function (selector) { return ({
            listen: function (listener, listenerOptions) {
                return new EventHandler({
                    root: root,
                    eventType: eventType,
                    selector: selector,
                    listener: listener,
                    listenerOptions: listenerOptions,
                });
            }
        }); }
    }); }
}); };
